import Vue from 'vue'
import Router from 'vue-router'
import distribution from '../components/Distribution/Distribution.vue'
import dashboard from '../components/Dashboard.vue'
import customers from '../components/Customers/Customers.vue'
import offers from '../components/Offers/Offers.vue'
import purchaseOrders from '../components/PurchaseOrders/PurchaseOrders.vue'
import procurements from '../components/Procurements/Procurements.vue'
import supplierOrders from '../components/SupplierOrders/SupplierOrders.vue'
import followUp from '../components/FollowUp/FollowUp.vue'
import invoices from '../components/Invoices/Invoices.vue'
import productListings from '../components/ProductListings/ProductListings.vue'
import Login from '../components/Login.vue'
/* import settings from '../components/Settings/Settings.vue' */
import account from '../components/Settings/Account/Account.vue'
import suppliers from '../components/Settings/Suppliers/Suppliers.vue'
import manufacturers from '../components/Settings/Manufacturers/Manufacturers.vue'
import products from '../components/Settings/Products/Products.vue'
import contactFunctions from '../components/Settings/ContactFunctions/ContactFunctions.vue'
import termsOfDeliveries from '../components/Settings/TermsOfDelivery/TermsOfDelivery.vue'
import termsOfPayments from '../components/Settings/TermsOfPayment/TermsOfPayment.vue'
import users from '../components/Settings/Users/Users.vue'
import brandConfiguration from '../components/Settings/BrandConfiguration/BrandConfiguration.vue'
import cashFlow from '../components/CashFlow/CashFlow.vue'
import AuthGuard from './auth-guard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: dashboard,
      beforeEnter: AuthGuard
    },
    {
      path: '/offers',
      name: 'Offers',
      component: offers,
      beforeEnter: AuthGuard
    },
    {
      path: '/purchaseOrders',
      name: 'Purchase Orders',
      component: purchaseOrders,
      beforeEnter: AuthGuard
    },
    {
      path: '/supplierOrders',
      name: 'Supplier Orders',
      component: supplierOrders,
      beforeEnter: AuthGuard
    },
    {
      path: '/followUp',
      name: 'Follow-up',
      component: followUp,
      beforeEnter: AuthGuard
    },
    {
      path: '/invoice',
      name: 'Invoice',
      component: invoices,
      beforeEnter: AuthGuard
    },
    {
      path: '/procurements',
      name: 'Procurements',
      component: procurements,
      beforeEnter: AuthGuard
    },
    {
      path: '/inquiries',
      name: 'Inquiries',
      component: distribution,
      beforeEnter: AuthGuard
    },
    {
      path: '/productListings',
      name: 'Product Listings',
      component: productListings,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings/account',
      name: 'Account',
      component: account,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings/customers',
      name: 'Customers',
      component: customers,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings/suppliers',
      name: 'Suppliers',
      component: suppliers,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings/manufacturers',
      name: 'Manufacturers',
      component: manufacturers,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings/products',
      name: 'Products',
      component: products,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings/contactFunctions',
      name: 'ContactFunctions',
      component: contactFunctions,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings/termsOfDeliveries',
      name: 'TermsOfDeliveries',
      component: termsOfDeliveries,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings/termsOfPayments',
      name: 'TermsOfPayments',
      component: termsOfPayments,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings/users',
      name: 'Users',
      component: users,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings/brandConfiguration',
      name: 'Brand Configuration',
      component: brandConfiguration,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings/cashFlow',
      name: 'Cash Flow',
      component: cashFlow,
      beforeEnter: AuthGuard
    },
    /*    {
      path: '/settings',
      name: 'Settings',
      component: settings,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings/:module/:id',
      name: 'SettingsDetail',
      component: settings,
      beforeEnter: AuthGuard
    }, */
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '*',
      redirect: '/dashboard'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js